<app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>


<div *ngIf="!containsError">
    <div class="pageHeader" id="serviceTransfersListHeader">List of Servicer Transfers</div>

  <div *ngIf="noTranSel != null && noTranSel.length >0" class="no-trans-selected">
    <li class="error-list-msg">{{noTranSel}}</li>

  </div>

  <div  *ngIf="servicerTransferSummaryList" class="u-scroll-x">

    <div class="row u-ml-650">
      <div  class="download-button">

        <div class="select-style">
          <fm-select
            [options]="pageView"
            placeholder="Choose"
            [(ngModel)]="selectedPageView"></fm-select>
        </div>
        <button fmButton class="ok-button" type="button" [small]="true" label="Ok" (click)='pageViewAction(dt)'></button>
      </div>
    </div>
    <br>


    <div class="row u-ml-10">
    <fm-table #dt [columns]="displayCols" [value]="servicerTransferSummaryList"
              [paginator]="true" [rows]="10"
              [compressed]="true" [autoLayout]="true" [exportFilename]="exportFilename"
              [rowsPerPageOptions]="[10,25,50]" [enableTableEntryTotal]="true">
      <ng-template fmTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns"  class="row-selection">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template fmTemplate="body" let-rowData let-columns="columns">
        <tr>
          <td class="td-content" *ngFor="let col of columns">
            <span *ngIf="col.header==='Portfolio Indicator' && rowData[col.field]==='Partial'">
              <a  (click)="showLoanDetails(rowData)" class="detail-link">{{rowData[col.field]}} </a>
            </span>
            <span *ngIf="col.header==='Effective Date' || col.header==='Receipt Date'"> {{(rowData[col.field])}}</span>
            <span *ngIf="col.header==='Status'"> {{(rowData[col.field])}}</span>

            <span *ngIf="(col.header!=='Portfolio Indicator' || rowData[col.field]!=='Partial')
                && col.header!=='Effective Date' && col.header!=='Receipt Date'
                && col.header!=='Status'"> {{rowData[col.field]}}</span>


            <span *ngIf="col.header==='Delete ?' && deleteEnableCheckboxFlag  ">

            <span *ngIf="internalUpdateRoleFlag !=='true' && isAdminrole!=='true' ">
                <fm-checkbox #deleteCheckbox [value]="rowData" [disabled]="! ((rowData['servTransferStatus']).code === 'Pending' || (rowData['servTransferStatus']).code ==='Pending For Approval')"></fm-checkbox>
            </span>


            <span *ngIf="internalUpdateRoleFlag ==='true' || isAdminrole ==='true'">
                <fm-checkbox #deleteCheckbox [value]="rowData" [disabled]="! ((rowData['servTransferStatus']).code === 'Pending' || (rowData['servTransferStatus']).code ==='Pending For Approval' || (rowData['servTransferStatus']).code ==='Approved')"></fm-checkbox>
            </span>

            </span>

            <span *ngIf="col.header==='Approve ?' && approveEnableCheckboxFlag" >
              <fm-checkbox #approveCheckbox [value]="rowData" [disabled]="   (!(internalUpdateRoleFlag ==='true' || isAdminrole ==='true')) || (! ((rowData['servTransferStatus']).code === 'Pending' || (rowData['servTransferStatus']).code =='Pending For Approval'))"></fm-checkbox>
            </span>

          </td>
        </tr>
      </ng-template>
    </fm-table>
    </div>
  </div>
  <span></span>

  <div class="u-mb-150">
    <button *ngIf="deleteEnableCheckboxFlag || approveEnableCheckboxFlag" fmButton type="submit" [primary]="true" [small]="true" label="Select All"
           (click)="selectAll()" class="buttonmargin"></button>

    <button  *ngIf="deleteEnableCheckboxFlag || approveEnableCheckboxFlag"  fmButton type="button" (click)="unSelectAll()" [primary]="true" label="Unselect All" [small]="true" class="buttonmargin"></button>

    <button fmButton type="button" *ngIf="deleteEnableCheckboxFlag" [primary]="true" (click)="deleteTransfer()" label="Delete Transfer" [small]="true" class="buttonmargin"></button>

    <button fmButton type="button" *ngIf="approveEnableCheckboxFlag" [primary]="true" (click)="approveTransfer()" label="Approve Transfer" [small]="true" class="buttonmargin"></button>

    <button fmButton type="button" [primary]="true" label="Cancel" [small]="true" (click)="onCancel()"
            class="buttonmargin"></button>

  </div>

</div>
